module.exports = __webpack_public_path__ + "img/knighttemplar.418f6109.gif";